import { http, HttpResponse } from 'msw';
import { PlessService } from './../../../app/shared/pless-service.model';
import { ResponseUtils } from './../response-utils';

export const kymw73Handlers = [
  // 注文単位値引クーポン一覧削除 /kymw73/deleteCouponList
  http.post(PlessService.SERVICE.deleteCouponList.url, async ({ request }) => {
    const req = await request;
    return ResponseUtils.getSuccess();
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 注文単位値引クーポン一覧取得 /kymw73/getCouponList
  http.post(PlessService.SERVICE.getCouponList.url, async ({ request }) => {
    const req = await request;
    return HttpResponse.json(getCouponListResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 注文単位値引クーポン情報取得 /kymw73/getCoupon
  http.post(PlessService.SERVICE.getCoupon.url, async ({ request }) => {
    const req = await request;
    return HttpResponse.json(getCouponResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 注文単位値引クーポン情報更新 /kymw73/updateCoupon
  http.post(PlessService.SERVICE.updateCoupon.url, async ({ request }) => {
    const req = await request;
    return ResponseUtils.getSuccess();
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 注文単位値引クーポン情報新規追加 /kymw73/addCoupon
  http.post(PlessService.SERVICE.addCoupon.url, async ({ request }) => {
    const req = await request;
    return ResponseUtils.getSuccess();
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 受付期間取得 /kymw73/getReceiptCatalog
  http.post(PlessService.SERVICE.getReceiptCatalog.url, async ({ request }) => {
    const req = await request;
    return HttpResponse.json(getReceiptCatalogResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),
];

const getCouponListResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      TotalNum: '100',
      StartDispNum: '1',
      EndDispNum: '100',
      CouponList: [
        {
          CouponGoodsNo: '0000000001',
          CouponOrderCd: '000001',
          CouponName: 'クーポン１',
          CouponIssueCatalogStart: '20240801',
          CouponIssueCatalogEnd: '20240901',
          CouponReceiptCatalogStart: '20240802',
          CouponReceiptCatalogEnd: '20240902',
          CouponCategory: '01',
          CouponCategoryName: 'クーポン種別１',
          NoticeExistenceType: '1',
          NoticeExistenceTypeName: '通知有無区分１',
          NoticeMethodTypeItem: '1',
          NoticeMethodTypeNameItem: '通知区分お届け１',
          NoticeMethodTypeMail: '1',
          NoticeMethodTypeNameMail: '通知区分メルマガ１',
        },
        {
          CouponGoodsNo: '0000000002',
          CouponOrderCd: '000002',
          CouponName: 'クーポン２',
          CouponIssueCatalogStart: '20240901',
          CouponIssueCatalogEnd: '20241001',
          CouponReceiptCatalogStart: '20240902',
          CouponReceiptCatalogEnd: '20241002',
          CouponCategory: '01',
          CouponCategoryName: 'クーポン種別２',
          NoticeExistenceType: '2',
          NoticeExistenceTypeName: '通知有無区分２',
          NoticeMethodTypeItem: '2',
          NoticeMethodTypeNameItem: '通知区分お届け２',
          NoticeMethodTypeMail: '2',
          NoticeMethodTypeNameMail: '通知区分メルマガ２',
        },
      ],
    },
  },
};

const getCouponResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      // CouponCategory: '01',
      // CouponCategory: '02',
      CouponCategory: '03',
      // CouponCategory: '04',
      CouponOrderCd: '000001',
      NoticeExistenceType: '1',
      NoticeMethodTypeItem: '1',
      NoticeMethodTypeMail: '1',
      UseStandardPrice: '1000000',
      StartMemberWeek: '10',
      EndMemberWeek: '12',
      CouponIssueCatalogStart: '20250201',
      CouponIssueCatalogEnd: '20250202',
      ValidWeek: '20',
      CouponReceiptCatalogStart: '20250203',
      CouponReceiptCatalogEnd: '20250204',
      DiscountPrice: '2000000',
      CouponName: 'クーポン名',
      CouponNameKana: 'クーポン名（カナ）',
      EcTitle: 'ＥＣタイトル',
      DetailsTitle: 'ＥＣタイトル',
      UseTerms: '一回のご利用金額（本体）１，０００，０００円以上で',
      DiscountedAmount: '２，０００，０００円引きクーポン',
      ValidatedDate: '有効期限　２０２５年３月１回まで',
      CpgrpCd: '9',
      CouponGoodsNo: '0000000001',
      CoopCodeList: [
        {
          CoopCode: '142',
        },
        {
          CoopCode: '163',
        },
        {
          CoopCode: '185',
        },
        {
          CoopCode: '240',
        },
        {
          CoopCode: '210',
        },
        {
          CoopCode: '302',
        },
        {
          CoopCode: '515',
        },
        {
          CoopCode: '451',
        },
      ],
    },
  },
};

const getReceiptCatalogResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      ReceiptCatalog: '20240801',
    },
  },
};
